import { put, call, takeLatest, all } from 'redux-saga/effects';
import { processRequest } from '../../../services/Api';
import { licenseInviteLinkModalActionTypes } from './Constants';
import * as errorHandlerActions from '../../errorHandler/Actions';
import * as licenseInviteLinkModalActions from './Actions';

export default function* () {
	yield all([
		yield takeLatest(
			licenseInviteLinkModalActionTypes.GET_LICENSE_INVITE_LINK,
			handleGetLicenseInviteLinkRequest,
		),
	]);
}

export function* handleGetLicenseInviteLinkRequest({ payload }) {
	try {
		const { id } = payload || {};

		const { data } = yield call(processRequest, `admin/licenses/${id}/invite_link`);

		yield put(licenseInviteLinkModalActions.getLicenseInviteLinkSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(licenseInviteLinkModalActions.getLicenseInviteLinkError());
	}
}
